export const teddyPath = (teddyId: Number) => `/teddy/${teddyId}`;
